module.exports = __webpack_public_path__ + "static/media/Metalflix.525b756d.png";